module.exports = __webpack_public_path__ + "static/media/logo-central-de-abasto.28485138.JPG";